import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cookie from 'js-cookie';
import applyReducer from './applyReducer';
import loginConstants from '../constants/loginConstants';
import mfaConstants from '../constants/mfaConstants';
import employeeConstants from '../constants/employeeConstants';
import { getStorage } from '../utils/storage';
const safeParseRememberMe = cookieValue => {
  try {
    return JSON.parse(cookieValue || 'false');
  } catch (error) {
    // If JSON parsing fails, default to false
    return false;
  }
};
const initState = {
  clearPassword: false,
  customer: '',
  error: null,
  geolocation: {},
  isAuthenticated: false,
  loaded: true,
  mfa: false,
  mfaSetup: false,
  passwordExpired: false,
  showForgotPassword: false,
  user: null,
  loading: false,
  shouldSetNewEmail: false,
  showCUIPolicy: false,
  acceptedCUIPrompt: false,
  ssoProviders: {},
  // { providerName: { enabled, loginUrl, settings, checking } }
  availableSSOProviders: [],
  // Array of enabled provider names (e.g., ['entra'])
  ssoConfigRequestCustomer: null // Customer name for in-flight SSO check (stale-response guard)
};
const acceptCUIPrompt = state => _objectSpread(_objectSpread({}, state), {}, {
  acceptedCUIPrompt: true,
  showCUIPolicy: false
});
const enforceCUIPolicy = state => _objectSpread(_objectSpread({}, state), {}, {
  showCUIPolicy: true
});
const forgotPasswordFail = state => _objectSpread(_objectSpread({}, state), {}, {
  showForgotPassword: false
});
const forgotPasswordSuccess = state => _objectSpread(_objectSpread({}, state), {}, {
  showForgotPassword: false
});
const forgotPasswordToggle = state => _objectSpread(_objectSpread({}, state), {}, {
  showForgotPassword: !state.showForgotPassword
});
const geolocationFailure = state => {
  const storage = getStorage(state === null || state === void 0 ? void 0 : state.user);
  storage.removeItem('geolocation');
  return _objectSpread(_objectSpread({}, state), {}, {
    geolocation: initState.geolocation
  });
};
const geolocationSuccess = (state, action) => {
  const geolocation = action.data;
  const storage = getStorage(state === null || state === void 0 ? void 0 : state.user);
  storage.removeItem('geolocation');
  storage.setItem('geolocation', JSON.stringify(geolocation));
  return _objectSpread(_objectSpread({}, state), {}, {
    geolocation
  });
};
const login = state => _objectSpread(_objectSpread({}, state), {}, {
  loaded: false,
  clearPassword: false
});
const loginFail = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  clearPassword: true,
  error: action.data && action.data.error_msg,
  loaded: true,
  mfa: false
});
const loginSuccess = (state, action) => {
  getStorage(action.user).setItem('user', JSON.stringify(action.user));
  return _objectSpread(_objectSpread({}, state), {}, {
    clearPassword: true,
    customer: action.user.customer || state.customer,
    error: null,
    isAuthenticated: true,
    loaded: true,
    user: action.user,
    shouldSetNewEmail: !(action.user && action.user.email)
  });
};
const employeeSaveSucces = (state, action) => {
  if (state.shouldSetNewEmail && action.data && action.data.email) {
    const newUser = _objectSpread(_objectSpread({}, state.user), {}, {
      email: action.data.email
    });
    const storage = getStorage(newUser);
    // make sure storage has newly saved emailAddress
    storage.setItem('user', JSON.stringify(newUser));
    return _objectSpread(_objectSpread({}, state), {}, {
      shouldSetNewEmail: false,
      user: newUser
    });
  }
  return state;
};
const logout = state => {
  // Auth keys are cleared in loginActionCreators.logoutUser (both storages).
  // We do not clear storage here so logoutMessage is preserved for the login page.
  if (!safeParseRememberMe(cookie.get('rememberMe'))) {
    cookie.remove('customer');
    cookie.remove('username');
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    clearPassword: false,
    error: null,
    geolocation: {},
    isAuthenticated: false,
    user: {},
    ssoProviders: {},
    availableSSOProviders: [],
    ssoConfigRequestCustomer: null
  });
};
const mfaRequired = (state, _ref) => {
  let data = _ref.data;
  return _objectSpread(_objectSpread({}, state), {}, {
    error: data.error_msg,
    mfa: true,
    loaded: true
  });
};
const mfaSetupRequired = (state, _ref2) => {
  let user = _ref2.user;
  return _objectSpread(_objectSpread({}, state), {}, {
    customer: user.customer,
    loaded: true,
    mfaSetup: true,
    user
  });
};
const setMFA = state => _objectSpread(_objectSpread({}, state), {}, {
  mfa: true
});
const clearMFA = state => _objectSpread(_objectSpread({}, state), {}, {
  mfa: false
});
const passwordExpired = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  customer: action.user.customer,
  passwordExpired: true,
  user: action.user,
  error: action.data.error_msg
});

// this reducer has a corresponding reducer in `passwordReducer`
const passwordSaveSuccess = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  passwordExpired: false,
  user: _objectSpread(_objectSpread({}, state.user), action.user)
});
const token = state => _objectSpread(_objectSpread({}, state), {}, {
  loading: true
});
const tokenSuccess = state => _objectSpread(_objectSpread({}, state), {}, {
  loading: false
});
const autoLogoutWithSave = (state, _ref3) => {
  let data = _ref3.data;
  return _objectSpread(_objectSpread({}, state), {}, {
    error: data.error_msg
  });
};
const checkSSOConfig = (state, action) => {
  const _ref4 = action.data || {},
    provider = _ref4.provider,
    customer = _ref4.customer;
  // If provider is null, we're checking all providers - set checking state for all
  if (provider === null) {
    const updatedProviders = _objectSpread({}, state.ssoProviders);
    const hasExistingProviders = Object.keys(updatedProviders).length > 0;
    if (hasExistingProviders) {
      // Mark all existing providers as checking
      Object.keys(updatedProviders).forEach(providerName => {
        updatedProviders[providerName] = _objectSpread(_objectSpread({}, updatedProviders[providerName] || {}), {}, {
          checking: true
        });
      });
    } else {
      // Initialize known providers with checking: true for first discovery call (silent)
      // Currently only Entra is supported, but structure allows for future providers
      updatedProviders.entra = {
        enabled: false,
        loginUrl: null,
        settings: null,
        checking: true
      };
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      ssoProviders: updatedProviders,
      ssoConfigRequestCustomer: customer !== null && customer !== void 0 ? customer : state.ssoConfigRequestCustomer
    });
  }
  // If a specific provider is provided, mark only that one as checking
  if (provider) {
    return _objectSpread(_objectSpread({}, state), {}, {
      ssoProviders: _objectSpread(_objectSpread({}, state.ssoProviders), {}, {
        [provider]: _objectSpread(_objectSpread({}, state.ssoProviders[provider] || {}), {}, {
          checking: true
        })
      }),
      ssoConfigRequestCustomer: customer !== null && customer !== void 0 ? customer : state.ssoConfigRequestCustomer
    });
  }
  // If provider is undefined or empty string, return state unchanged
  return state;
};
const checkSSOConfigSuccess = (state, action) => {
  const _action$data = action.data,
    providers = _action$data.providers,
    availableProviders = _action$data.availableProviders;
  // Rebuild from new response only (do not merge into existing) so providers
  // no longer returned/enabled are removed; keeps state authoritative
  const updatedProviders = {};
  Object.keys(providers || {}).forEach(providerName => {
    const providerData = providers[providerName];
    updatedProviders[providerName] = {
      enabled: providerData.enabled || false,
      loginUrl: providerData.loginUrl || null,
      settings: providerData.settings || null,
      checking: false
    };
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    ssoProviders: updatedProviders,
    availableSSOProviders: availableProviders || [],
    ssoConfigRequestCustomer: null
  });
};
const checkSSOConfigFail = (state, action) => {
  const _ref5 = action.data || {},
    provider = _ref5.provider;
  if (provider) {
    // Clear specific provider
    const updatedProviders = _objectSpread({}, state.ssoProviders);
    updatedProviders[provider] = {
      enabled: false,
      loginUrl: null,
      settings: null,
      checking: false
    };
    return _objectSpread(_objectSpread({}, state), {}, {
      ssoProviders: updatedProviders,
      availableSSOProviders: state.availableSSOProviders.filter(p => p !== provider),
      ssoConfigRequestCustomer: null
    });
  }
  // Clear all providers
  return _objectSpread(_objectSpread({}, state), {}, {
    ssoProviders: {},
    availableSSOProviders: [],
    ssoConfigRequestCustomer: null
  });
};
const clearSSOConfig = state => _objectSpread(_objectSpread({}, state), {}, {
  ssoProviders: {},
  availableSSOProviders: [],
  ssoConfigRequestCustomer: null
});
const reducers = {
  [loginConstants.ACCEPT_CUI_POLICY]: acceptCUIPrompt,
  [loginConstants.AUTO_LOGOUT_WITH_SAVE]: autoLogoutWithSave,
  [loginConstants.CHECK_SSO_CONFIG]: checkSSOConfig,
  [loginConstants.CHECK_SSO_CONFIG_SUCCESS]: checkSSOConfigSuccess,
  [loginConstants.CHECK_SSO_CONFIG_FAIL]: checkSSOConfigFail,
  [loginConstants.CLEAR_SSO_CONFIG]: clearSSOConfig,
  [loginConstants.ENFORCE_CUI_POLICY]: enforceCUIPolicy,
  [loginConstants.FORGOT_PASSWORD_FAIL]: forgotPasswordFail,
  [loginConstants.FORGOT_PASSWORD_SUCCESS]: forgotPasswordSuccess,
  [loginConstants.FORGOT_PASSWORD_TOGGLE]: forgotPasswordToggle,
  [loginConstants.GEOLOCATION_FAILURE]: geolocationFailure,
  [loginConstants.GEOLOCATION_SUCCESS]: geolocationSuccess,
  [loginConstants.LOGIN]: login,
  [loginConstants.LOGIN_FAIL]: loginFail,
  [loginConstants.LOGIN_SUCCESS]: loginSuccess,
  [loginConstants.LOGOUT]: logout,
  [loginConstants.MFA_REQUIRED]: mfaRequired,
  [loginConstants.MFA_SETUP_REQUIRED]: mfaSetupRequired,
  [loginConstants.PASSWORD_EXPIRED]: passwordExpired,
  [loginConstants.PASSWORD_SAVE_SUCCESS]: passwordSaveSuccess,
  [mfaConstants.MFA_SAVE_SUCCESS]: setMFA,
  [mfaConstants.MFA_DESTROY_SUCCESS]: clearMFA,
  [loginConstants.TOKEN]: token,
  [loginConstants.TOKEN_SUCCESS]: tokenSuccess,
  [employeeConstants.SAVE_SUCCESS]: employeeSaveSucces
};
export default applyReducer(reducers, initState);